import InterpretationInterface from './interpretation-interface';

class DraftkingsInterpretation implements InterpretationInterface {
    interpretPlayerExternalId(content: string): string {
        const [, id] = content.split('(');

        return id.replace(')', '').trim();
    }
}

export default DraftkingsInterpretation;
